import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ONBOARDING_REPOSITORY } from '../domain/repositories/onboarding.repository';
import { OnboardingRemoteDatasource } from './datasources/remote/onboarding.remote-datasource';
import { OnboardingMapper } from './mappers/onboarding.mapper';
import { OnboardingRepositoryImpl } from './repositories/onboarding.repository.impl';

export function provideOnboardingData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    OnboardingRemoteDatasource,
    OnboardingMapper,
    { provide: ONBOARDING_REPOSITORY, useClass: OnboardingRepositoryImpl },
  ]);
}
